module.exports = __webpack_public_path__ + "img/guide1.b971a01a.png";